import { TIENDA_HANDY } from "config";

/**
 * Función para manejar borderRadius de forma global
 * Retorna 0 si es TIENDA_HANDY, de lo contrario retorna el radius por defecto
 *
 * Esta NO es un hook de React, es una función normal que se puede usar en cualquier lugar
 *
 * @param {string|number} defaultRadius - El borderRadius por defecto a usar
 * @returns {string|number} - El borderRadius a aplicar
 */
const getBorderRadius = (defaultRadius = "16px") => {
  return TIENDA_HANDY ? 0 : defaultRadius;
};

/**
 * Hook personalizado para manejar borderRadius (solo usar en componentes principales)
 * Retorna 0 si es TIENDA_HANDY, de lo contrario retorna el radius por defecto
 *
 * @param {string|number} defaultRadius - El borderRadius por defecto a usar
 * @returns {string|number} - El borderRadius a aplicar
 */
const useBorderRadius = (defaultRadius = "16px") => {
  return TIENDA_HANDY ? 0 : defaultRadius;
};

export default useBorderRadius;
export { getBorderRadius };
